import React, { useEffect, useRef } from "react";
import BirthdayLaunchBanner from "./BirthdayLaunchBanner";
import FallLaunchBanner from "./FallLaunchBanner";
import PreviewSelfCountdownBanner from "./PreviewSelfCountdownBanner";

// Fixed strip that stacks the premium-preview banners ABOVE the fixed header.
// The header lives at `top: var(--app-banner-h)` and page content is offset by
// the same var, so this bar publishes its own live height to --app-banner-h.
// When nothing is showing the height is 0 and the layout is untouched.
export default function PreviewBannerBar() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === "undefined") return;
    const setVar = () => {
      const h = Math.round(el.getBoundingClientRect().height);
      document.documentElement.style.setProperty("--app-banner-h", `${h}px`);
    };
    setVar();
    const ro = new ResizeObserver(setVar);
    ro.observe(el);
    return () => {
      ro.disconnect();
      document.documentElement.style.setProperty("--app-banner-h", "0px");
    };
  }, []);
  return (
    <div ref={ref} className="fixed top-0 left-0 right-0 z-[60]" data-testid="preview-banner-bar">
      <BirthdayLaunchBanner />
      <FallLaunchBanner />
      <PreviewSelfCountdownBanner />
    </div>
  );
}
